// extracted by mini-css-extract-plugin
export default {"list":"zY-ZaMaj","left":"_1I20OGon","right":"_2RIPc05O"};